export const SIMPLE_FILES_FILTER = "SIMPLE_FILES_FILTER"
export const SIMPLE_FILES_FILTER_SUCCESS = "SIMPLE_FILES_FILTER_SUCCESS"
export const SIMPLE_FILES_FILTER_ERROR = "SIMPLE_FILES_FILTER_ERROR"

export const SIMPLE_FILES_SEGMENTS = "SIMPLE_FILES_SEGMENTS"
export const SIMPLE_FILES_SEGMENTS_SUCCESS = "SIMPLE_FILES_SEGMENTS_SUCCESS"
export const SIMPLE_FILES_SEGMENTS_ERROR = "SIMPLE_FILES_SEGMENTS_ERROR"

export const SIMPLE_FILES_LIST = "SIMPLE_FILES_LIST"
export const SIMPLE_FILES_LIST_SUCCESS = "SIMPLE_FILES_LIST_SUCCESS"
export const SIMPLE_FILES_LIST_ERROR = "SIMPLE_FILES_LIST_ERROR"

export const SIMPLE_FILES_DOWNLOAD = "SIMPLE_FILES_DOWNLOAD"
